import { createAction } from 'automation-ui-core/ambient-types/flux-actions';
import * as ActionTypes from 'automation-ui-canvas/actions/ActionTypes';
export const setOpenId = createAction(ActionTypes.MENU_BAR_SET_OPEN_ID, ({
  openId
}) => ({
  openId
}));
export const setIsActive = createAction(ActionTypes.MENU_BAR_SET_IS_ACTIVE, ({
  isActive
}) => ({
  isActive
}));
export const setModalStateById = createAction(ActionTypes.MENU_BAR_SET_MODAL_STATE_BY_ID, ({
  menuOptionId,
  modalState
}) => ({
  menuOptionId,
  modalState
}));